import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { Layer, VectorSource, Popup } from 'mapbox-gl';
import { MapStore } from '@/store/map';
import { libLigne } from '@/services/lib-ligne.service';
import { gareUtLibelleService } from '@/services/gare_ut_libelle.service';
import { busRoute } from '@/services/internet4G&4G.servie';

export const AddTrainRoutes = () => {
  const mapStore = getModule(MapStore, store);
  let source: { type: 'geojson'; data: string } = {
    type: 'geojson',
    data: JSON.parse(libLigne())
  };
  let layer: Layer = {
    id: 'TrainRouteCurrent',
    type: 'line',
    source: 'TrainRouteCurrent',
    layout: {},
    paint: {
      'line-width': 3,
      'line-color': [
        'match',
        ['get', 'catlig'],
        'Ligne à grande vitesse',
        '#ef694a',
        'Ligne du réseau conventionnel',
        '#313b54',
        '#313b54'
      ]
    }
  };
  mapStore.addSource({ source, type: 'TrainRouteCurrent' });
  mapStore.addLayer({ layer, type: 'TrainRouteCurrent' });

  source = {
    type: 'geojson',
    data: JSON.parse(gareUtLibelleService())
  };
  layer = {
    id: 'TrainRouteLabelCurrent',
    type: 'circle',
    source: 'TrainRouteLabelCurrent',
    layout: {},
    paint: {
      'circle-color': '#313b54',
      'circle-radius': 5,
      'circle-stroke-color': '#fff',
      'circle-stroke-width': 2
    }
  };
  mapStore.map.on('click', 'TrainRouteLabelCurrent', e => {
    if ('coordinates' in e.features[0].geometry) {
      const coordinates = e.features[0].geometry.coordinates.slice();
      const description = e.features[0].properties.gare_alias_libelle_noncontraint;
      new Popup({ offset: 25, maxWidth: '500px', className: 'popuptest' })
        // @ts-ignore
        .setLngLat(coordinates)
        .setHTML(
          `<div style="border-radius: 150px; height: 10px; display: flex; align-items:center; box-shadow: 0 10px 24px 0 rgba(0, 0, 0, 0.2);">
                  <h3 style="font-family: Montserrat,serif;
                  font-size: 18px;color: grey; font-weight: bold; height: 20px" class="popup__title">
                     ${description}</h3>
                  </div>`
        )
        .addTo(mapStore.map);
    }
  });
  mapStore.map.on('mouseenter', 'TrainRouteLabelCurrent', function() {
    mapStore.map.getCanvas().style.cursor = 'pointer';
  });
  mapStore.map.on('mouseleave', 'TrainRouteLabelCurrent', function() {
    mapStore.map.getCanvas().style.cursor = '';
  });
  mapStore.addSource({ source, type: 'TrainRouteLabelCurrent' });
  mapStore.addLayer({ layer, type: 'TrainRouteLabelCurrent' });
};
export const AddTrainRoutesFuture = (year: any, id: number, years: Array<any>) => {
  const mapStore = getModule(MapStore, store);
  let source: VectorSource = {
    type: 'vector',
    url: 'mapbox://maplabtech.1x8ldj3r'
  };
  const newYears = [...years];
  // newYears.shift();
  let previousOne;
  let previousTwo;
  let previousThree;
  if (newYears[id - 1]) {
    previousOne = String(newYears[id - 1]);
  } else {
    previousOne = '20250';
  }
  if (newYears[id - 2]) {
    previousTwo = String(newYears[id - 2]);
  } else {
    previousTwo = '20150';
  }
  if (newYears[id - 3]) {
    previousThree = String(newYears[id - 3]);
  } else {
    previousThree = '20160';
  }
  let layer: Layer = {
    id: 'TrainRoute',
    type: 'line',
    source: 'TrainRoute',
    'source-layer': 'RGPE-a8vjqt',
    paint: {
      'line-width': 6,
      'line-color': [
        'match',
        ['get', 'Annee_MeS'],
        year,
        '#00b6bc',
        previousOne,
        '#00b6bc',
        previousTwo,
        '#00b6bc',
        previousThree,
        '#00b6bc',
        '#00b6bc'
      ],
      'line-opacity': ['match', ['get', 'Annee_MeS'], year, 1, previousOne, 1, previousTwo, 1, previousThree, 1, 0]
    }
  };
  mapStore.addSource({ source, type: 'TrainRoute' });
  mapStore.addLayer({ layer, type: 'TrainRoute' });

  source = {
    type: 'vector',
    url: 'mapbox://maplabtech.3mbm40hm'
  };
  layer = {
    id: 'TrainRouteLabel',
    type: 'circle',
    source: 'TrainRouteLabel',
    'source-layer': 'RGPE_Station_1-5p9tog',
    layout: {},
    paint: {
      'circle-color': '#000000',
      'circle-radius': 6,
      'circle-pitch-scale': 'viewport',
      'circle-opacity': [
        'match',
        ['get', 'Annee_MeS'],
        year,
        0.4,
        previousOne,
        0.4,
        previousTwo,
        0.4,
        previousThree,
        0.4,
        0
      ]
    }
  };
  mapStore.map.on('click', 'TrainRouteLabel', e => {
    if ('coordinates' in e.features[0].geometry) {
      const coordinates = e.features[0].geometry.coordinates.slice();
      const description = e.features[0].properties.LIBELLE;
      new Popup({ offset: 25, maxWidth: '500px', className: 'popuptest' })
        // @ts-ignore
        .setLngLat(coordinates)
        .setHTML(
          `<div style="border-radius: 150px; height: 10px; display: flex; align-items:center;">
                  <h3 style="font-family: Montserrat,serif;
                  font-size: 18px;color: grey; font-weight: bold; height: 20px" class="popup__title">
                     ${description}</h3>
                  </div>`
        )
        .addTo(mapStore.map);
    }
  });
  mapStore.map.on('mouseenter', 'TrainRouteLabel', function() {
    mapStore.map.getCanvas().style.cursor = 'pointer';
  });
  mapStore.map.on('mouseleave', 'TrainRouteLabel', function() {
    mapStore.map.getCanvas().style.cursor = '';
  });
  mapStore.addSource({ source, type: 'TrainRouteLabel' });
  mapStore.addLayer({ layer, type: 'TrainRouteLabel' });
};

export const RemoveRoutes = (type: any) => {
  const mapStore = getModule(MapStore, store);

  mapStore.removeOnlyLayer({ type: type });
  mapStore.removeOnlyLayer({ type: type + 'Label' });
  mapStore.removeSource({ type: type });
};

export const AddBusRoutes = () => {
  const mapStore = getModule(MapStore, store);
  const source: { type: 'geojson'; data: string } = {
    type: 'geojson',
    data: JSON.parse(busRoute())
  };
  const layer: Layer = {
    id: 'BusRoute',
    type: 'line',
    source: 'BusRoute',
    paint: {
      'line-width': 3,
      'line-color': '#0d2f7c'
    }
  };
  mapStore.addSource({ source, type: 'BusRoute' });
  mapStore.addLayer({ layer, type: 'BusRoute' });
};
